/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Camera_Field_StreamInputs */

const vi_grower_area_camera_field_stream = /** @type {(inputs: Grower_Area_Camera_Field_StreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Token stream`)
};

/**

* @param {Grower_Area_Camera_Field_StreamInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_camera_field_stream = /** @type {((inputs?: Grower_Area_Camera_Field_StreamInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Camera_Field_StreamInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_camera_field_stream(inputs)
});